import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAppointmentRecommendations } from '@hooks/useAppointmentRecommendations';
import { SessionFormItem } from './SessionFormItem';

export const GeneralAdviceFormItem = () => {
  const { t } = useTranslation('common');
  const { defaultGeneralAdviceValue, generalAdviceMeta, onChangeGeneralAdvice, readOnly } =
    useAppointmentRecommendations();

  if (!generalAdviceMeta) return null;

  const options = Object.keys(generalAdviceMeta).map((item) => ({
    label: item,
    value: item,
    options: generalAdviceMeta[item].map(({ genadv_code, genadv_desc }) => ({
      label: genadv_desc,
      value: genadv_code
    }))
  }));

  return (
    <SessionFormItem label={t('GeneralAdvice')} linkAria>
      <Select
        mode="multiple"
        onChange={(value) => {
          const selectedGeneralAdvice = value.map((code) => ({
            genadv_code: String(code)
          }));

          onChangeGeneralAdvice(selectedGeneralAdvice);
        }}
        defaultValue={defaultGeneralAdviceValue}
        disabled={readOnly}
        options={options}
        data-testid="general-advice-select"
      />
    </SessionFormItem>
  );
};
